import { ClassesBuilder } from '@utilities';

const classesConfig = {
  button: 'font-semibold text-white px-4 py-2 rounded-md whitespace-nowrap transition hover:scale-105 active:scale-95',
  roundedButton: 'rounded-full',
  smallButton: 'text-xs',
};

export default new ClassesBuilder(classesConfig);
